import { Tooltip } from '@mui/material';
import { GridRow, GridRowProps } from '@mui/x-data-grid';

interface Props extends GridRowProps {
  tooltip: string;
}

export const GridRowWithTooltip = ({ tooltip, ...props }: Props) => {
  return (
    <Tooltip title={tooltip}>
      <GridRow {...props} />
    </Tooltip>
  );
};
